import {IntlShape} from 'react-intl';

export const statusColorMap = new Map<string, string>([
    ['Lancée', '#5b70b0'],
    ['Attente livraison', '#710080'],
    ['Résiliation demandée', '#de8100'],
    ['Livrée', '#5da170'],
    ['En production', '#5da170'],
    ['Résilié', '#ababab'],
]);

export const getStatusColor = (status: string): string => {
    return statusColorMap.get(status) || '#888';
};

const statusLabelKeyMap = new Map<string, string>([
    ['Lancée', 'SERVICE.STATE.LAUNCHED'],
    ['Attente livraison', 'SERVICE.STATE.WAITING_DELIVERY'],
    ['Résiliation demandée', 'SERVICE.STATE.TERMINATION_REQUESTED'],
    ['Livrée', 'SERVICE.STATE.DELIVERED'],
    ['En production', 'SERVICE.STATE.IN_PRODUCTION'],
    ['Résilié', 'SERVICE.STATE.TERMINATED'],
]);

export const getStatusLabel = (status: string | null, intl: IntlShape): string => {
    if (!status) {
        return '';
    }
    const messageId = statusLabelKeyMap.get(status);
    return messageId ? intl.formatMessage({id: messageId}) : status;
};